import { TemplateMode } from '../Model/TemplateMode';
var Widget = /** @class */ (function () {
    function Widget(appearance, trigger, conditions, widget) {
        this._appearance = appearance;
        this._trigger = trigger;
        this._conditions = conditions;
        this._widget = widget;
    }
    Object.defineProperty(Widget.prototype, "sort", {
        get: function () {
            return this._widget.sort;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "widgetKey", {
        get: function () {
            return this._widget.widgetKey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "widget", {
        get: function () {
            return this._widget;
        },
        enumerable: false,
        configurable: true
    });
    Widget.prototype.register = function () {
        var _this = this;
        if (this._conditions && !this._conditions.every(function (condition) {
            return !condition.canBeCached || condition.check();
        })) {
            return false;
        }
        this._trigger.register(function () {
            _this.show();
        });
        return true;
    };
    Widget.prototype.render = function (template, mode, submitCb, hideAction, isPresentational) {
        var _this = this;
        if (mode === void 0) { mode = TemplateMode.Desktop; }
        if (isPresentational === void 0) { isPresentational = false; }
        return this._widget.render(template, mode, function (url) {
            if (submitCb) {
                submitCb();
            }
            document.location.replace(url);
        }, function () {
            if (hideAction) {
                hideAction();
            }
            else {
                _this.hide();
            }
        }, this.resize.bind(this), isPresentational);
    };
    Widget.prototype.getProviderId = function () {
        return this._widget.getProviderId();
    };
    Widget.prototype.show = function () {
        if (this.canShow()) {
            this._appearance.show(this);
        }
    };
    Widget.prototype.resize = function (state, size) {
        this._appearance.resize(state, size);
    };
    Widget.prototype.hide = function () {
        this._appearance.hide(this);
        this._trigger.destroy();
    };
    Widget.prototype.destroy = function () {
        this._appearance.destroy(this);
        this._trigger.destroy(false);
    };
    Widget.prototype.canShow = function () {
        var canShow = true;
        if (this._conditions) {
            canShow = canShow && this._conditions.every(function (condition) {
                return condition.canBeCached || condition.check();
            });
        }
        canShow = canShow && this._widget.canShow();
        canShow = canShow && this._appearance.canShow();
        return canShow;
    };
    return Widget;
}());
export { Widget };
